export const aggregateMaterialData = (products) => {
  return products.flatMap((product) => [
    ...product.materialData,
    ...(product.crossSellData
      ? aggregateMaterialData(product.crossSellData)
      : []),
  ])
}

export const getMaterialTypes = (productData) => {
  const types = []
  productData.forEach((product) => {
    product.materialData.forEach(({ type }) => {
      if (!types.includes(type)) {
        types.push(type)
      }
    })
    product.crossSellData?.forEach((crossSell) => {
      crossSell.materialData.forEach(({ type }) => {
        if (!types.includes(type)) {
          types.push(type)
        }
      })
    })
  })
  return types
}

export const findProductData = (modelCode, products) => {
  for (const product of products) {
    if (product.modelCode === modelCode) {
      return product
    }
    if (product.crossSellData && product.crossSellData.length > 0) {
      const found = findProductData(modelCode, product.crossSellData)
      if (found) {
        return found
      }
    }
  }
  return null
}

export const getModelLength = (productData) => {
  if (!productData || productData.length === 0) {
    return 0
  }
  let modelLength = 0
  modelLength += productData.length
  productData.forEach((product) => {
    if (product.crossSellData && product.crossSellData.length > 0) {
      modelLength += product.crossSellData.length
    }
  })
  return modelLength
}
